"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.electricityLayer = void 0;
const buildings_1 = require("../config/buildings");
exports.electricityLayer = {
    name: 'electricity',
    tickRate: 1,
    execute(state, _tick) {
        var _a;
        const elec = state.layers.electricity;
        let supply = 0;
        let demand = 0;
        let storageCapacity = 0;
        // Sort buildings by id for determinism
        const sorted = [...state.buildings].sort((a, b) => a.id.localeCompare(b.id));
        for (const building of sorted) {
            if (!building.isEnabled)
                continue;
            const config = buildings_1.allBuildings[building.name];
            if (!config)
                continue;
            const levelConfig = config.levels[building.level];
            if (!levelConfig)
                continue;
            if (config.type === 'energy') {
                // Solar panel generates energy
                const provides = levelConfig.provides;
                const energyGen = provides['energy'] || 0;
                const modifier = (_a = elec.efficiencyModifiers[building.id]) !== null && _a !== void 0 ? _a : 1;
                supply += energyGen * modifier;
            }
            if (config.type === 'storage' && building.name === 'battery') {
                // Battery provides storage capacity
                const stores = levelConfig.stores;
                storageCapacity += stores['energy'] || 0;
            }
            if (config.type === 'mining' || config.type === 'factory' || config.type === 'minibot-factory') {
                // These consume energy
                const costs = levelConfig.costs;
                demand += costs['energy'] || 0;
            }
        }
        // Process balance
        let stored = elec.stored;
        let availableSupply;
        if (supply >= demand) {
            // Surplus — charge batteries
            const surplus = supply - demand;
            stored = Math.min(stored + surplus, storageCapacity);
            availableSupply = demand;
        }
        else if (stored + supply >= demand) {
            // Use batteries to cover deficit
            const deficit = demand - supply;
            stored -= deficit;
            availableSupply = demand;
        }
        else {
            // Blackout
            stored = 0;
            availableSupply = 0;
        }
        return Object.assign(Object.assign({}, state), { layers: Object.assign(Object.assign({}, state.layers), { electricity: Object.assign(Object.assign({}, elec), { supply: availableSupply, demand,
                    stored,
                    storageCapacity }) }) });
    },
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/layers/electricity.js
// module id = FADj
// module chunks = 0